import {AuthService} from '../../login/services/auth.service';
import { Injectable } from '@angular/core';
import { HTTPService } from "../../shared/services/http.service";
import { BillingDetails } from '../models/billing-details';
import { BillingCard } from '../models/billing-card';
import { StripePaymentProcessor } from '../../shared/services/stripe-payment-processor.service';
import { SubscriptionHydratorService } from './subscription-hydrator.service';

@Injectable()
export class BillingService {

    constructor(private httpService:HTTPService, private authService:AuthService
        , private stripeService:StripePaymentProcessor
        , private subHydrator:SubscriptionHydratorService) {

    }

    public getBillingDetails() : Promise<BillingDetails> {
        return this.authService.getCurrentUser().then(user => {
            return this.httpService.get("/admin/billing/" + user.companyID)
            .then((response) => {
                let data = response.json() as any;
                let cards = data.cards || data._cards || [];
                let subscriptions = data.subscriptions || data._subscriptions || [];

                let billingDetails = Object.assign(new BillingDetails(), data);
                if (cards.length) {
                    billingDetails.cards = cards.map(c => Object.assign(new BillingCard(), c));
                }
                if (subscriptions.length) {
                    billingDetails.subscriptions = subscriptions.map(s => this.subHydrator.fromJSONObject(s));
                }
                return billingDetails;
            })
            .catch((error) => {
                // no details found at all
                if (error.status == 404) {
                    return new BillingDetails(); // make it empty
                }
                throw error;
            });
        });
        
    }

    public updateDefaultBillingCard(billingDetails:BillingDetails) {
        return this.authService.getCurrentUser().then(user => {
            return this.stripeService.createUpdateCardToken("Update card for Assessment Services", billingDetails.email)
            .then((token) => {
                console.log("token updated for customer.  Token now: ", token);
                let promise;
                if (!billingDetails.customerId) {
                    // create new billing profile
                    promise = this.httpService.post("/admin/billing/", {companyID: user.companyID, card:token});
                }
                else {
                    // or update the existing card for the current billing profile
                    promise = this.httpService.post("/admin/billing/" + user.companyID + "/card/", {card: token});
                }
                
                return promise.then((resp) => {
                    let newBilling = resp.json() as any;
                    Object.assign(billingDetails, newBilling);
                    let cards = newBilling.cards || newBilling._cards || [];
                    billingDetails.cards = cards.map(c => Object.assign(new BillingCard(), c));
                    let subscriptions = newBilling.subscriptions || newBilling._subscriptions || [];
                    billingDetails.subscriptions = subscriptions.map(s => this.subHydrator.fromJSONObject(s));
                    return billingDetails;
                });
            });
        });
    }

    public deleteDefaultBillingCard(billingDetails:BillingDetails) : Promise<any> {
        
        if (billingDetails.cards.length) {
            return this.authService.getCurrentUser().then(user =>{
                return this.httpService.delete("/admin/billing/" + user.companyID + "/card/").then(() => {
                    billingDetails.cards = []; // clear out the cards.
                    return billingDetails;
                });
            });
        }
        return Promise.reject(new Error("Default billing card is missing to delete"));
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/billing.service.ts